module.exports = __webpack_public_path__ + "media/images/lp_V6_cvbtn-18342eab34ebee8decb0f6a1cf56a25d.webp";